// extracted by mini-css-extract-plugin
export var logo = "_ka-2";
export var logoWrapper = "_ka-1";
export var strip = "_ka-0";